import React, { useState, forwardRef, useImperativeHandle } from "react";
import CustomConfirm from "./CustomConfirm";
import { apiRequest } from "../../utils/config/apiRequest";

const DeleteHandler = forwardRef(
  (
    {
      disabled = false,
      heading,
      content,
      apiUrl,
      onDelete = () => {},
      id,
      onTempDelete = () => {},
      open,
      setOpen,
      showTriggerButton = true,
    },
    ref
  ) => {
    const [openConfirm, setOpenConfirm] = useState(false);
    const isOpen = open !== undefined ? open : openConfirm;
    const toggleOpen = setOpen || setOpenConfirm;

    const handleDelete = async () => {
      toggleOpen(false);
      if (!id) {
        onTempDelete();
        return;
      }

      let { status } = await apiRequest({
        endUrl: apiUrl,
        method: "DELETE",
        params: { id },
        showMsg: true,
      });

      status && onDelete();
    };

    useImperativeHandle(ref, () => ({
      openModal: () => toggleOpen(true),
    }));

    return (
      <>
        {showTriggerButton && (
          <button
            disabled={disabled}
            className="btn-md card-btn btn-outline-secondary"
            onClick={() => toggleOpen(true)}
          >
            <i className="fa-solid fa-trash"></i> Delete
          </button>
        )}

        <CustomConfirm
          open={isOpen}
          heading={heading || "Are you want remove record?"}
          content={<p>{content || ""}</p>}
          confirmText="Delete"
          onConfirm={handleDelete}
          onClose={() => toggleOpen(false)}
          onDecline={() => toggleOpen(false)}
        />
      </>
    );
  }
);

export default DeleteHandler;
